module.exports = __webpack_public_path__ + "img/Marca19.31047841.jpg";